/** Must match R2_PUBLIC_URL in .env (set REACT_APP_R2_PUBLIC_URL before npm start / build). */
const R2_PUBLIC_BASE = (process.env.REACT_APP_R2_PUBLIC_URL || '').replace(/\/$/, '');

export function storageUrl(keyOrPath) {
    if (!keyOrPath) return '';
    return `${R2_PUBLIC_BASE}/${String(keyOrPath).replace(/^\//, '')}`;
}

export function profilePictureUrl(filename) {
    if (!filename) return null;
    return storageUrl(`profile-pictures/${filename}`);
}

export function themeImageUrl(themeId) {
    return storageUrl(`themes/${themeId}.png`);
}
